import * as m from "~/paraglide/messages.js";
import type { ServicePage } from "./types";

export function getResearchPage(): ServicePage {
  return {
    art: {
      body: m.svc_research_art_body(),
      foot: m.svc_research_art_foot(),
      heading: m.svc_research_art_heading(),
      kind: "sample-document",
      source: { icon: "googledocs", label: m.svc_research_art_source() },
    },
    artNote: m.svc_research_art_note(),
    capabilityId: "research",
    cta: { lede: m.svc_research_cta_lede(), title: m.svc_research_cta_title() },
    faq: [
      {
        answer: m.svc_research_faq_1_answer(),
        question: m.svc_research_faq_1_question(),
      },
      {
        answer: m.svc_research_faq_2_answer(),
        question: m.svc_research_faq_2_question(),
      },
      {
        answer: m.svc_research_faq_3_answer(),
        question: m.svc_research_faq_3_question(),
      },
      {
        answer: m.svc_research_faq_4_answer(),
        question: m.svc_research_faq_4_question(),
      },
    ],
    intro: m.svc_research_intro(),
    keywords:
      "AI research agent, AI research assistant, AI market research, AI lead research, AI competitor analysis, automated research, AI izpēte, AI izpētes aģenti",
    label: m.svc_research_label(),
    limits: {
      body: m.svc_research_limits_body(),
      items: [
        {
          term: m.svc_research_limit_1_term(),
          value: m.svc_research_limit_1_value(),
        },
        {
          term: m.svc_research_limit_2_term(),
          value: m.svc_research_limit_2_value(),
        },
        {
          term: m.svc_research_limit_3_term(),
          value: m.svc_research_limit_3_value(),
        },
      ],
      title: m.svc_research_limits_title(),
    },
    meta: {
      description: m.svc_research_meta_description(),
      title: m.svc_research_meta_title(),
    },
    nav: m.svc_research_nav(),
    scope: {
      body: m.svc_research_scope_body(),
      points: [
        m.svc_research_scope_point_1(),
        m.svc_research_scope_point_2(),
        m.svc_research_scope_point_3(),
        m.svc_research_scope_point_4(),
      ],
      title: m.svc_research_scope_title(),
    },
    serviceType: "AI research agents",
    slug: "ai-research-agents",
    steps: {
      body: m.svc_research_steps_body(),
      items: [
        m.svc_research_step_1(),
        m.svc_research_step_2(),
        m.svc_research_step_3(),
        m.svc_research_step_4(),
      ],
      title: m.svc_research_steps_title(),
    },
    title: [m.svc_research_title_1(), m.svc_research_title_2()],
    uses: [
      {
        term: m.svc_research_use_1_term(),
        value: m.svc_research_use_1_value(),
      },
      {
        term: m.svc_research_use_2_term(),
        value: m.svc_research_use_2_value(),
      },
      {
        term: m.svc_research_use_3_term(),
        value: m.svc_research_use_3_value(),
      },
      {
        term: m.svc_research_use_4_term(),
        value: m.svc_research_use_4_value(),
      },
    ],
  };
}
